import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { DEFAULT_PAGE_SIZE } from 'constants/catalog';
import { PagedResult } from 'types/api';
import { Facet, ProductListResult } from 'types/product';
import { asProductList, mapStoreProduct, StoreProductApiItem } from 'utils/mapStoreProduct';

type SearchApi = PagedResult<StoreProductApiItem> & {
  facets?: Facet[];
  appliedFilters?: Record<string, string[]>;
  priceMin?: number;
  priceMax?: number;
};

const searchService = {
  search: async (
    q: string,
    pageNumber = 1,
    pageSize = DEFAULT_PAGE_SIZE,
    facets?: Record<string, string[]>,
    track = false,
    minPrice?: number,
    maxPrice?: number
  ): Promise<ProductListResult> => {
    const params: Record<string, string | number | boolean> = { q, pageNumber, pageSize };
    if (track) params.track = true;
    if (minPrice != null) params.minPrice = minPrice;
    if (maxPrice != null) params.maxPrice = maxPrice;
    Object.entries(facets ?? {}).forEach(([key, values]) => {
      if (values?.length) params[`f.${key}`] = values.join('|');
    });
    const response = await api.get<SearchApi>(ENDPOINTS.SEARCH, { params });
    const data = response.data;
    return {
      items: asProductList(data).map(mapStoreProduct),
      totalCount: data.totalCount ?? 0,
      pageNumber: data.pageNumber ?? 1,
      pageSize: data.pageSize ?? DEFAULT_PAGE_SIZE,
      totalPages: data.totalPages ?? 0,
      facets: data.facets ?? [],
      appliedFilters: data.appliedFilters ?? {},
      priceMin: data.priceMin,
      priceMax: data.priceMax,
    };
  },
};

export default searchService;
